module.exports = __webpack_public_path__ + "img/article-gb-dwrg-4.749ba6a0.jpg";